export enum eDelegationWorkflowFeature {
  apiPath = '/delegation-workflow/delegation-workflow',
  enableDisablePath = '/delegation-workflow/enable-disable-delegation-workflow',
}
